import type { TersaImageModel } from '../../types';
import { qwenModels } from './qwen';
import { wanModels } from './wan';
import { zimageModels } from './zimage';

export const alibabaModels: Record<string, TersaImageModel> = {
    ...qwenModels,
    ...wanModels,
    ...zimageModels,
};